import { defineComponent as S, reactive as x, ref as k, computed as l, watch as C, nextTick as M, createElementBlock as i, openBlock as o, withModifiers as L, normalizeStyle as n, createBlock as p, withCtx as T, createElementVNode as w, toDisplayString as A, createCommentVNode as N, Fragment as $, renderList as D } from "vue";
import _ from "./Avatar.js";
import { _ as B } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
/* empty css                                                                     */
import { _ as G } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const O = { class: "tess-avatar-group__empty" }, P = {
  key: 1,
  class: "tess-avatar-group__content"
}, R = /* @__PURE__ */ S({
  __name: "AvatarGroup",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    labelKey: {
      type: String,
      default: "display_name"
    },
    iconKey: {
      type: String,
      default: "icon"
    },
    imageKey: {
      type: String,
      default: "profile_image"
    },
    isMeKey: {
      type: String,
      default: "is_me"
    },
    urlKey: {
      type: String,
      default: "url"
    },
    isOpenNewTabKey: {
      type: String,
      default: "is_open_new_tab"
    },
    disableHover: {
      type: Boolean,
      default: !1
    },
    bgColorKey: {
      type: String,
      default: "bg_color"
    },
    textColorKey: {
      type: String,
      default: "text_color"
    },
    tooltipKey: {
      type: String,
      default: "display_name"
    },
    bgColor: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    },
    gap: {
      type: Number,
      default: 0
    },
    displayLimit: {
      type: Number,
      default: 4
    },
    shortLabelKey: {
      type: String,
      default: "initial"
    },
    isUseShortLabel: {
      type: Boolean,
      default: !0
    },
    emptyText: {
      type: String,
      default: "No assignee"
    },
    emptyTooltip: {
      type: String,
      default: ""
    }
  },
  emits: ["click:on-group", "click:on-avatar"],
  setup(b, { emit: f }) {
    const e = b;
    x({});
    const u = k(0), c = f, s = l(() => {
      const a = e.displayLimit - 1;
      return a > 0 ? Math.min(a, e.data.length) : 0;
    }), m = l(() => e.data.sort((r, t) => r[e.isMeKey] && !t[e.isMeKey] ? -1 : !r[e.isMeKey] && t[e.isMeKey] ? 1 : 0).slice(0, s.value).reverse().map((r, t) => {
      const d = (e.gap === 0 ? 2 : 0) * (s.value - t - 1);
      return {
        ...r,
        position_in_group: {
          right: `${d}px`
        }
      };
    })), y = l(() => {
      const a = e.data.length - s.value;
      return a <= 0 ? "" : `${a}+`;
    }), v = l(() => ({
      right: `${(e.gap === 0 ? 2 : 0) * s.value}px`
    })), h = l(() => ({
      "--group-gap": `${e.gap}px`
    })), K = () => {
      c("click:on-group");
    }, g = () => {
      c("click:on-avatar");
    };
    return C(
      () => e.data,
      (a) => {
        M(() => {
          a && (u.value += 1);
        });
      }
    ), (a, r) => (o(), i("div", {
      class: "tess-avatar-group",
      style: n(h.value),
      onClick: L(K, ["stop"])
    }, [
      e.data.length ? (o(), i("div", P, [
        y.value ? (o(), p(_, {
          key: 0,
          class: "tess-avatar-group__item",
          label: y.value,
          "disable-hover": !0,
          "bg-color": e.bgColor,
          "text-color": e.textColor,
          "is-use-short-label": e.isUseShortLabel,
          style: n(v.value),
          "onClick:onAvatar": g
        }, null, 8, ["label", "bg-color", "text-color", "is-use-short-label", "style"])) : N("", !0),
        (o(!0), i($, null, D(m.value, (t, d) => (o(), p(_, {
          class: "tess-avatar-group__item",
          key: `${t.id}-${u.value}`,
          image: t[e.imageKey],
          label: t[e.labelKey],
          icon: t[e.iconKey],
          isMe: t[e.isMeKey],
          "is-use-short-label": e.isUseShortLabel,
          "short-label": t[e.shortLabelKey],
          "bg-color": t[e.bgColorKey],
          url: t[e.urlKey],
          "is-open-new-tab": t[e.isOpenNewTabKey],
          "text-color": t[e.textColorKey],
          "label-tooltip": t[e.tooltipKey],
          style: n(t.position_in_group),
          "disable-hover": e.disableHover,
          "onClick:onAvatar": g
        }, null, 8, ["image", "label", "icon", "isMe", "is-use-short-label", "short-label", "bg-color", "url", "is-open-new-tab", "text-color", "label-tooltip", "style", "disable-hover"]))), 128))
      ])) : (o(), p(B, {
        key: 0,
        class: "tess-avatar-group__tooltip",
        content: e.emptyTooltip,
        delay: [300, 0]
      }, {
        default: T(() => [
          w("div", O, A(e.emptyText), 1)
        ]),
        _: 1
      }, 8, ["content"]))
    ], 4));
  }
}), z = /* @__PURE__ */ G(R, [["__scopeId", "data-v-b6c663ee"]]);
export {
  z as default
};
